import React, { Suspense } from 'react';
import EditContainer from "./EditContainer";

const EditSegmentation = (props) => {
    return (
        <EditContainer {...props} />
    );
};

export default EditSegmentation;